import { z } from 'zod'
import ApiService from '../api.service'

const createSchema = z.object({
    emHoras: z.boolean(),
    trabalha: z.union([z.number(), z.string()]),
    folga: z.union([z.number(), z.string()]),
    descricao: z.string(),
    horaExtraNoFeriado: z.boolean(),
})

const transform = createSchema.transform(
    ({ emHoras, horaExtraNoFeriado, ...rest }) => ({
        ...rest,
        tipo: emHoras ? 'HORISTA' : 'DIARISTA',
        horaExtraNoFeriado: horaExtraNoFeriado ? 'S' : 'N',
    }),
)

type Input = z.input<typeof transform>

const updateSchama = createSchema
    .extend({
        id: z.number(),
    })
    .transform(({ emHoras, ...rest }) => ({
        ...rest,
        tipo: emHoras ? 'HORISTA' : 'DIARISTA',
    }))

type Output = z.output<typeof updateSchama>

const service = new ApiService<Input, Output>('escalas')

export type CreateEscalaInput = Input
export type Escalas = Output

export const escalas = service
export const createEscalaSchema = transform
